export default function isInViewport($el, offsetTop = 0) {
    const rect = $el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    const cond = (rect.top + windowHeight - offsetTop <= windowHeight) && ((rect.top + rect.height - offsetTop) >= 0);

    return cond;
}